import styled from '@emotion/styled'
import { AiOutlineLeft } from 'react-icons/ai'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import * as paths from '../../../constant/path'
import Text from '../../../components/common/Text'
import CoinFormatter from '../../../components/CoinFormatter'
import {
  useFetchUserCoinTransaction,
  useGetUserCoin,
  useGetUserExpiredCoin,
} from '../../../services/user/user-query'
import { DARK_GRAY, MEDIUM_GRAY, ORANGE, SHOP_PRIMARY, WHITE } from '../../../constant/colors'
import Button from '../../../components/common/Button'
import { convertDateFormatTH, DateFormat } from '../../../utils/dateFormat'
import dayjs from 'dayjs'

const Layout = styled.div`
  margin-top: 16px;
  ${mobile} {
    margin-top: 64px;
  }
`

const CoinSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0px -16px;
  background-color: ${WHITE};
  padding: 16px;
`

const HowToUseButton = styled(Button)`
  border-radius: 100px;
`

const CoinTransactionSection = styled.div`
  margin-top: 40px;

  ${mobile} {
    margin-top: 24px;
  }
`

const CoinTransactionText = styled(Text)`
  margin-bottom: 24px;

  ${mobile} {
    margin-bottom: 16px;
  }
`

const CoinTransactionCard = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${WHITE};
  margin-bottom: 16px;
  padding: 24px;

  ${mobile} {
    margin-bottom: 8px;
    padding: 16px;
  }
`

const CoinTransactionDetail = styled.div`
  display: flex;
  flex-direction: column;
`

const ShopUserCoin = () => {
  const { isMobile } = useScreen()
  const { data: userCoin = 0 } = useGetUserCoin()
  const { data: userExpiredCoin = '-' } = useGetUserExpiredCoin()
  const { data: userCoinTransaction } = useFetchUserCoinTransaction()

  const formatter = (data: number) => {
    return `${data}`.replace(/(\d)(?=(\d{3})+\b)/g, '$1,')
  }

  return (
    <Layout>
      {isMobile && (
        <TitleHeader title={'ประวัติของพ้อยท์'} icon={<AiOutlineLeft />} path={paths.shop()} />
      )}
      <CoinSection>
        <CoinFormatter
          value={userCoin || 0}
          textSize={48}
          textType="Bold"
          style={{ paddingBottom: 8 }}
        />
        <Text color={ORANGE}>{`มีค่าเท่ากับ ฿${formatter(userCoin)}`}</Text>
        <Text size={14} color={MEDIUM_GRAY} style={{ paddingBottom: 16 }}>
          {`หมดอายุ ณ วันที่ ${userExpiredCoin}`}
        </Text>
        <HowToUseButton
          fontColor={SHOP_PRIMARY}
          style={{
            background: 'transparent',
            marginRight: 8,
            borderColor: SHOP_PRIMARY,
          }}
        >
          วิธีการใช้งาน
        </HowToUseButton>
      </CoinSection>
      <CoinTransactionSection>
        <CoinTransactionText size={isMobile ? 24 : 32} color={DARK_GRAY} type={'Bold'}>
          ประวัติ
        </CoinTransactionText>
        {userCoinTransaction?.pages?.map((page) =>
          page?.content?.map((transaction, index) => {
            const createDateText = convertDateFormatTH(
              dayjs(transaction?.createdDate).toDate(),
              DateFormat.FORMAT_1TH,
            )
            return (
              <CoinTransactionCard key={index}>
                <CoinTransactionDetail>
                  <Text size={isMobile ? 18 : 24} color={DARK_GRAY} type={'Bold'}>
                    Order #{transaction?.id}
                  </Text>
                  <Text size={isMobile ? 14 : 18} color={DARK_GRAY}>
                    ได้รับแล้ว {createDateText}
                  </Text>
                </CoinTransactionDetail>
                <CoinFormatter
                  value={transaction?.coin || 0}
                  textSize={24}
                  textType="Bold"
                  style={{ paddingBottom: 8 }}
                />
              </CoinTransactionCard>
            )
          }),
        )}
      </CoinTransactionSection>
    </Layout>
  )
}

export default ShopUserCoin
